import { render } from "./ExpertisesComponent.vue?vue&type=template&id=639e028a&scoped=true"
import script from "./ExpertisesComponent.vue?vue&type=script&lang=js"
export * from "./ExpertisesComponent.vue?vue&type=script&lang=js"

import "./ExpertisesComponent.vue?vue&type=style&index=0&id=639e028a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639e028a"]])

export default __exports__